import useExperiment from '@hooks/useExperiment.experiments'
import {ANALYTICS_V2_FORCE} from './useLazyAnalyticsV2'

export default function useIsAnalyticsV2Avail() {
  const branchId = useExperiment('analytics-v2', {allowServerSide: true})
  return branchId === 'enabled' || ANALYTICS_V2_FORCE
}
